import "@/helpers/turbo"
import { application } from "./application"

import { initHomeSearch } from "@/components/elm_search"
import CarouselController from "../controllers/carousel_controller"
import TabsController from "../controllers/tabs_controller"

const setupStimulus = (): void => {
  application.register("carousel", CarouselController)
  application.register("tabs", TabsController)
}

initHomeSearch()
setupStimulus()
